import { render, staticRenderFns } from "./FeedbackSubheader.vue?vue&type=template&id=611449cd&scoped=true&lang=html&"
import script from "./FeedbackSubheader.vue?vue&type=script&lang=js&"
export * from "./FeedbackSubheader.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSubheader.vue?vue&type=style&index=0&id=611449cd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611449cd",
  null
  
)

export default component.exports